export { getScreenPosition } from './getScreenPosition';
export * from './formatters';
export * from './objects';
export * from './masks';

export const getTotalTimePerfomance = (startTime: number) => {
  const endTime = performance.now();

  const totalTimeInSeconds = (endTime - startTime) / 1000;
  const minutes = Math.floor(totalTimeInSeconds / 60);
  const seconds = Math.round(totalTimeInSeconds % 60);

  return `${minutes} min ${seconds} s`;
};
